import pairPsychotherapyQuestionSet from "../faq/pairPsychotherapy/allQuestions";

export const psychoterapyPair = {
    'meta': {
        'title': 'Psychoterapia par #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Psychoterapia par #cityLocativeIn#. Terapia par #cityLocativeIn#. Doświadczeni, certyfikowani psychoterapeuci pomogą Wam pokonać trudny okres w Waszym związku.'
    },
    'availability': [
        'torun',
        'bydgoszcz'
    ],
    'price': {
        'torun': {
            'first': 300,
            'next': 300
        },
        'bydgoszcz': {
            'first': 290,
            'next': 290
        }
    },
    'url': {
        'address': '#cityIdUrl#/uslugi/terapia-par/',
        'title': 'Psychoterapia par #cityLocativeIn#',
        'name': 'Psychoterapia par #cityLocativeIn#',
        'heading': 'Psychoterapia par #cityLocativeIn#',
        'fullName': 'Psychoterapia par'
    },
    'image': {
        'url': '/images/services/psychoterapia-par.webp',
        'width': 886,
        'height': 295,
        'alt': 'Psychoterapia par'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/psychoterapia-par.webp',
            'width': 886,
            'height': 295,
            'alt': 'Psychoterapia par'
        }
    },
    'faq': pairPsychotherapyQuestionSet
}